// import ActivitySubTask from "@components/common/ActivityRepositoryDetail/SubTasks";
// import ActivityTaskDetails from "@components/common/ActivityRepositoryDetail/TaskDetails";
// import ActivityTaskHistory from "@components/common/ActivityRepositoryDetail/TaskHistory";
import RepositoryMaster from "@pages/Repository/Master";
import RepositoryFunctionHead from "@pages/Repository/FunctionHead";
import RepositoryEvaluator from "@pages/Repository/Evaluator";
import SelfComplianceTaskDetailsPage from "@components/common/SelfComplianceDetail/TaskDetails";
import SelfComplianceTaskHistoryPage from "@components/common/SelfComplianceDetail/TaskHistory";
import ReportsLegalUpdate from "@pages/Reports/LegalUpdate";
import LegacyTask from "@pages/Repository/LegacyTask/Master";
import LegacyTaskDetailsPage from "@pages/Repository/LegacyTask/Master/view-task";
import LegacyTaskHistoryPage from "@pages/Repository/LegacyTask/Master/TaskHistory";
import LegacyTaskExecutor from "@pages/Repository/LegacyTask/Executor";
import LegacyTaskExecutorDetailsPage from "@pages/Repository/LegacyTask/Executor/view-details";
import ExecutorLegacyTaskHistoryPage from "@pages/Repository/LegacyTask/Executor/TaskHistory";
import LegacyTaskEvaluator from "@pages/Repository/LegacyTask/Evaluator";
import LegacyTaskEvaluatorDetailsPage from "@pages/Repository/LegacyTask/Evaluator/view-details";
import EvaluatorLegacyTaskHistoryPage from "@pages/Repository/LegacyTask/Evaluator/TaskHistory";
import LegacyTaskFunctionHead from "@pages/Repository/LegacyTask/FunctionHead";
import LegacyTaskFunctionHeadDetailsPage from "@pages/Repository/LegacyTask/FunctionHead/view-details";
import FunctionHeadLegacyTaskHistoryPage from "@pages/Repository/LegacyTask/FunctionHead/TaskHistory";
import DocumentLibrary from "@pages/DocumentLibrary";
import VendorComplianceRepositoryMaster from "@pages/Repository/VendorCompliance/Master";
import VendorComplianceMasterDetailsPage from "@pages/Repository/VendorCompliance/Master/view-task";
import VendorComplianceTaskHistoryPage from "@pages/Repository/VendorCompliance/Master/TaskHistory";
import TaskDocument from "@pages/Repository/TaskDocument";
import LegalUpdateCreate from "@pages/Reports/LegalUpdate/create";
// RepositoryCheckpointTaskDetails
// ReposityCheckpointTaskHistory
export const RepositoryRoutes = [
	// activities
	//Master
	{
		path: "/repository/mapped-checkpoint/master",
		name: "repository_mapped_checkpoint_master",
		component: RepositoryMaster,
	},
	{
		path: "/repository/mapped-checkpoint/master/task-details/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_master",
		component: SelfComplianceTaskDetailsPage,
	},
	{
		path: "/repository/mapped-checkpoint/master/task-history/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_master",
		component: SelfComplianceTaskHistoryPage,
	},
	// {
	// 	path: "/repository/mapped-checkpoint/master/sub-task/:id/:checkpoint_id",
	// 	name: "repository_mapped_checkpoint_master",
	// 	component: ActivitySubTask,
	// },

	//Function Head
	{
		path: "/repository/mapped-checkpoint/function-head",
		name: "repository_mapped_checkpoint_function_head",
		component: RepositoryFunctionHead,
	},
	{
		path: "/repository/mapped-checkpoint/function-head/task-details/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_function_head",
		component: SelfComplianceTaskDetailsPage,
	},
	{
		path: "/repository/mapped-checkpoint/function-head/task-history/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_function_head",
		component: SelfComplianceTaskHistoryPage,
	},
	// {
	// 	path: "/repository/mapped-checkpoint/function-head/sub-task/:id/:checkpoint_id",
	// 	name: "repository_mapped_checkpoint_function_head",
	// 	component: ActivitySubTask,
	// },

	//Evaluator
	{
		path: "/repository/mapped-checkpoint/evaluator",
		name: "repository_mapped_checkpoint_evaluator",
		component: RepositoryEvaluator,
	},
	{
		path: "/repository/mapped-checkpoint/evaluator/task-details/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_evaluator",
		component: SelfComplianceTaskDetailsPage,
	},
	{
		path: "/repository/mapped-checkpoint/evaluator/task-history/:id/:checkpoint_id",
		name: "repository_mapped_checkpoint_evaluator",
		component: SelfComplianceTaskHistoryPage,
	},
	// {
	// 	path: "/repository/mapped-checkpoint/evaluator/sub-task/:id/:checkpoint_id",
	// 	name: "repository_mapped_checkpoint_evaluator",
	// 	component: ActivitySubTask,
	// },

	//Legal Update
	{
		path: "/repository/legal-update",
		name: "repository_legal_update",
		component: ReportsLegalUpdate,
	},
	{
		path: "/repository/legal-update/create",
		name: "repository_legal_update",
		component: LegalUpdateCreate,
	},

	
	//Legacy Task > Master
	{
		path: "/repository/legacy-task/master",
		name: "repository_legacy_task_master",
		component: LegacyTask,
	},

	{
		path: "/repository/legacy-task/master/task-details/:id/:lexcare_task_id",
		name: "repository_legacy_task_master",
		component: LegacyTaskDetailsPage,
	},
	{
		path: "/repository/legacy-task/master/task-history/:id/:lexcare_task_id",
		name: "repository_legacy_task_master",
		component: LegacyTaskHistoryPage,
	},

	//Legacy Task > Executor
	{
		path: "/repository/legacy-task/executor",
		name: "repository_legacy_task_executor",
		component: LegacyTaskExecutor,
	},

	{
		path: "/repository/legacy-task/executor/task-details/:id/:lexcare_task_id",
		name: "repository_legacy_task_executor",
		component: LegacyTaskExecutorDetailsPage,
	},
	{
		path: "/repository/legacy-task/executor/task-history/:id/:lexcare_task_id",
		name: "repository_legacy_task_executor",
		component: ExecutorLegacyTaskHistoryPage,
	},

	//Legacy Task > Evaluator
	{
		path: "/repository/legacy-task/evaluator",
		name: "repository_legacy_task_evaluator",
		component: LegacyTaskEvaluator,
	},

	{
		path: "/repository/legacy-task/evaluator/task-details/:id/:lexcare_task_id",
		name: "repository_legacy_task_evaluator",
		component: LegacyTaskEvaluatorDetailsPage,
	},
	{
		path: "/repository/legacy-task/evaluator/task-history/:id/:lexcare_task_id",
		name: "repository_legacy_task_evaluator",
		component: EvaluatorLegacyTaskHistoryPage,
	},

	//Legacy Task > Function Head
	{
		path: "/repository/legacy-task/function-head",
		name: "repository_legacy_task_function_head",
		component: LegacyTaskFunctionHead,
	},

	{
		path: "/repository/legacy-task/function-head/task-details/:id/:lexcare_task_id",
		name: "repository_legacy_task_function_head",
		component: LegacyTaskFunctionHeadDetailsPage,
	},
	{
		path: "/repository/legacy-task/function-head/task-history/:id/:lexcare_task_id",
		name: "repository_legacy_task_function_head",
		component: FunctionHeadLegacyTaskHistoryPage,
	},

	{
		path: "/repository/document-library",
		name: "repository_document_library",
		component: DocumentLibrary
	},

	{
		path: "/repository/vendor-compliance/master",
		name: "repository_vendor_compliance_master",
		component: VendorComplianceRepositoryMaster,
	},

	{
		path: "/repository/vendor-compliance/master/task-details/:id/:checkpoint_id",
		name: "repository_vendor_compliance_master",
		component: VendorComplianceMasterDetailsPage,
	},

	{
		path: "/repository/vendor-compliance/master/task-history/:id/:checkpoint_id",
		name: "repository_vendor_compliance_master",
		component: VendorComplianceTaskHistoryPage,
	},

	{
		path: "/repository/task-document",
		name: "repository_task_library",
		component: TaskDocument
	},
	
];
